export const DEFAULT_ALLOCATION_SEARCH_PAGE_SIZE = 500;

export const ALLOCATION_TABLE_DEFAULT_PAGE_SIZE = 25;

export const ALLOCATION_TABLE_PAGE_SIZE_OPTIONS = ['25', '50', '100', '250', '500'];